import * as React from "react";
import { IconProps } from "./IconProps";

export const IconInfo = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="info, circle, tooltip">
          <path
            id="Icon (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.00004 2.66659C5.05452 2.66659 2.66671 5.0544 2.66671 7.99992C2.66671 10.9454 5.05452 13.3333 8.00004 13.3333C10.9456 13.3333 13.3334 10.9454 13.3334 7.99992C13.3334 5.0544 10.9456 2.66659 8.00004 2.66659ZM1.33337 7.99992C1.33337 4.31802 4.31814 1.33325 8.00004 1.33325C11.6819 1.33325 14.6667 4.31802 14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8.00004 14.6666C4.31814 14.6666 1.33337 11.6818 1.33337 7.99992ZM6.66671 7.33325C6.66671 6.96506 6.96518 6.66659 7.33337 6.66659H8.00004C8.36823 6.66659 8.66671 6.96506 8.66671 7.33325V10.6666C8.66671 11.0348 8.36823 11.3333 8.00004 11.3333C7.63185 11.3333 7.33337 11.0348 7.33337 10.6666V7.99992C6.96518 7.99992 6.66671 7.70144 6.66671 7.33325Z"
            fill={color}
          />
          <path
            id="Icon"
            d="M7.66663 5.33333C7.66663 5.14924 7.81586 5 7.99996 5C8.18405 5 8.33329 5.14924 8.33329 5.33333C8.33329 5.51743 8.18405 5.66667 7.99996 5.66667C7.81586 5.66667 7.66663 5.51743 7.66663 5.33333Z"
            fill={color}
          />
          <path
            id="Icon (Stroke)_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.00004 6.00008C7.63185 6.00008 7.33337 5.7016 7.33337 5.33341C7.33337 4.96522 7.63185 4.66675 8.00004 4.66675C8.36823 4.66675 8.66671 4.96522 8.66671 5.33341C8.66671 5.7016 8.36823 6.00008 8.00004 6.00008ZM8.00004 5.00008C7.81595 5.00008 7.66671 5.14932 7.66671 5.33341C7.66671 5.51751 7.81595 5.66675 8.00004 5.66675C8.18414 5.66675 8.33337 5.51751 8.33337 5.33341C8.33337 5.14932 8.18414 5.00008 8.00004 5.00008Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
